/**
 * A debounced function is called after [timeout] amount of time passes since its
 * last call. https://redd.one/blog/debounce-vs-throttle
 */
export const debounce = function (callback) {
  let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let timer;
  const debouncedFn = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, timeout);
  };
  debouncedFn.cancel = () => {
    clearTimeout(timer);
  };
  return debouncedFn;
};